module.exports = __webpack_public_path__ + "assets/img/advantage3.036bdbe1.png";